const OptionItem = (item, order) => {
  const title = item.value || item.optionTitle;
  return `<li data-listorder="${order}">
    <button type="button" data-role="list-selector">
      <span>
        ${item.isBundleOnly ? '<strong class="addoption">[추가구매상품]</strong>' : ''}
        ${title}
      </span>
    </button>
  </li>`;
};

export default OptionItem;
